import Request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 获取子账号列表
   */
  static getAccountList(params) {
    return Request({
      url: 'store/subAccount/querySubAccountByPage',
      host: config.HOST_STORE,
      params
    });
  }

  /**
   * 获取店铺钱包余额
   */
  static getWalletInfo() {
    return Request({
      url: `wallet/queryAccounts`,
      host: config.HOST_MALL
    });
  }

  /**
   * 店长查子账号钱包余额
   */
  static getSubAccountWalletInfo(subAccountId) {
    return Request({
      url: `wallet/shop/${subAccountId}/queryShopAccount`,
      host: config.HOST_MALL
    });
  }

  /**
   * 获取最新一项明细
   */
  static getLatestTransaction(pageSize, pageNum, params) {
    return Request({
      url: `wallet/shop/query/tradeInfos?pageSize=${pageSize}&pageNum=${pageNum}`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Store/Wallet/StoreWallet/StoreWalletServ.js